import {
  Tabs,
  Tag,
  Modal,
  Button,
  Form,
  Input,
  Select,
  message,
  Dropdown
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
  useRef,
} from "react";
import {
  PlusOutlined,
  EditOutlined,
  HomeOutlined,
  MenuOutlined,
  HistoryOutlined,
} from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
import AplianceModal from "./component/AplianceModal";
import { CustomTable, CustomTableExtend, CustomUpload, CustomModal } from "@/hocComponents";

const MainTable = forwardRef((props, ref) => {
  const [tabsKey, setTabsKey] = useState(1);
  const modalRef = useRef(null);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [filePaths, setFilePaths] = useState([]);
  const [selectedList, setSelectedList] = useState([]);
  const [storeList, setStoreList] = useState([]);

  const [filedModalFlag, setFiledModalFlag] = useState(false);
  const [detailRecord, setDetailRecord] = useState({});
  const [customModalLoading, setCustomModalLoading] = useState(false);

  const controllersRef = useRef([])

  const createController = () => {
    const controller = new AbortController()
    controllersRef.current.push(controller)
    return controller
  }

  const cancelAllRequests = () => {
    controllersRef.current.forEach(c => c?.abort())
    controllersRef.current = []
  }
  
  const initTableHead = {
    qrCode: undefined,
    purchaseStartTime: undefined,
    purchaseEndTime: undefined,
    propUnitStr: undefined,
    appStoreId: undefined,
  }
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn, pageSize: 100})
  }

  const initColumns = [
    {
      title: "Action",
      key: "action",
      dataIndex: "",
      // hidden: [].includes(tabsKey),
      align: "center",
      width: 60,
      render: (text, record) => (
        (
          (tabsKey === 1 && (commonFn.btnAuthorityFlag('Edit') || commonFn.btnAuthorityFlag('Delete')))
        ) && (<Dropdown
            menu={{
              items: [
                (tabsKey === 1 && commonFn.btnAuthorityFlag('Edit')) && {
                  key: "edit",
                  icon: <EditOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
                  label: <div>Edit</div>,
                },
                (tabsKey === 1 && commonFn.btnAuthorityFlag('Delete')) && {
                  key: "delete",
                  icon: <HistoryOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
                  label: <div>Delete</div>,
                },
              ],
              onClick: (e) => handleMenuClick(e, record),
            }}
            trigger={["click"]}
          >
            <MenuOutlined
              style={{ cursor: "pointer", fontSize: "16px", color: "#0e78a9" }}
            />
          </Dropdown>)
      )
    },
    {
      title: 'Number',
      dataIndex: "qrCode",
      titleType: 'Input',
      onChange: (e) => tableFilterFn(e, "qrCode"),
    },
    {
      title: 'PO.Date',
      dataIndex: "purchaseTime",
      titleType: "RangePicker",
      isArrayDate: true,
      onChange: (e) => tableFilterFn(e, ['purchaseStartTime', 'purchaseEndTime'], 'RangePicker'),
    },
    {
      title: 'Prop - Unit',
      dataIndex: "propUnitStr",
      titleType: 'Input',
      onChange: (e) => tableFilterFn(e, "propUnitStr"),
    },
    {
      title: "Store Name",
      dataIndex: "storeName",
      titleType: "Select",
      width: 100,
      selectOptions: storeList,
      onChange: (e) => tableFilterFn(e, "appStoreId", "Select"),
    },
  ]

  const [columns, setColumns] = useState(initColumns);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 100,
    total: 0,
  });

  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    const controller = createController()
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      type: tabsKey,
      ...tableHead,
    };
    const response = await http.post(api.aplianceList, {...params}, {signal: controller.signal});
    if(!response) return
    if (response && response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    const list = (response.data.list || []).map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const initColunmsFn = () => {
    setPagination({
      current: 1,
      pageSize: 100,
      total: 0,
    })
    setTableList([])
    setSelectedList([])
    setTableHead(initTableHead);
    setColumns(initColumns);
    cancelAllRequests()
  }

  useEffect(() => {
    initColunmsFn()
    getTableListFn(1, 100)
  }, [refreshKey])

  const getAplianceStoreList = async () => {
    const response = await http.get(api.aplianceStoreList);
    setStoreList(response?.data || []);
  };  

  useEffect(() => {
    getAplianceStoreList();
  }, []);

  useEffect(() => {
    if (storeList?.length) {
      setColumns(initColumns);
    }
  }, [storeList]);

  const customModalRef = useRef(null);
  const [currentRecord, setCurrentRecord] = useState(null);

  // 新增修改
  const AplianceRef = useRef(null);

  const handleMenuClick = async (item, record = {}) => {
    const { key } = item
    const nameMatch = {
      1: 'Refrigerator'
    }
    if(["New"].includes(key)) {
      AplianceRef.current.openModal({
        type: 'add',
        modalName: `New ${nameMatch[tabsKey]}`,
        oldState: {
          ...record,
          type: tabsKey
        }
      })
    } else if(["edit"].includes(key)) {
      AplianceRef.current.openModal({
        type: 'edit',
        modalName: `Edit ${nameMatch[tabsKey]}`,
        oldState: {
          ...record,
          type: tabsKey
        }
      })
    } else if(["delete"].includes(key)) {
      setCurrentRecord({
        ...record,
        modalName: nameMatch[tabsKey],
      })
      customModalRef.current.openModalFn();
    }
  }

  const deleteFn = async() => {
    setCustomModalLoading(true)
    const response = await http.get(api.aplianceDelete, {
      params: {
        ids: currentRecord?.id,
      },
    });
    if (response.code === "1") {
      message.success("Successfully delete.");
      getTableListFn(pagination.current, pagination.pageSize, { ...tableHead });
    } else {
      commonFn.modalFailedFn(response);
    }
    setCustomModalLoading(false)
  }

  const submitInitFn = () => {
    setSelectedList([])
    setTableHead(pre => {
      getTableListFn(pagination.current, pagination.pageSize, pre)
      return pre
    })
  }

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('Download') && 'download']}
      >
        <Tabs 
          defaultActiveKey={tabsKey} 
          items={[
            {key: 1, label: "Refrigerator"},
          ]}
          onChange={key => (setTabsKey(key), setRefreshKey(+new Date()))}
        />
      </CustomTableExtend>
      {
        tabsKey === 1 && [{
          name: 'New',
          key: 'New',
          type: 'primary',
          icon: <PlusOutlined />,
          className: 'btnGreen'
        }]?.map(item => (
          <commonFn.BtnAuthorityFn authKey={item.key}>
            <Button type={item.type} style={{marginBottom: 20}} onClick={() => handleMenuClick(item)}>
              {item?.icon}
              {item?.name}
            </Button>
          </commonFn.BtnAuthorityFn>
        )) || null
      }
      <CustomTable 
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowSelection={[2].includes(tabsKey) && {
          preserveSelectedRowKeys: true,
          type: tabsKey === 1 ? "radio" : "checkbox ",
          selectedRowKeys: selectedList.map(item => item.id),
          onChange: (selectedRowKeys, selectedRows) => {
            setSelectedList(selectedRows);
          },
        } || false}
        rowKey="id"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollY="430px"
      />

      <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <HomeOutlined style={{ marginRight: "8px" }} />
            File
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        centered
        open={filedModalFlag}
        onCancel={() => setFiledModalFlag(false)}
        footer={null}
        maskClosable={false}
        // destroyOnClose={true}
        width="80%"
      >
      <div
        key={detailRecord?.id}
        style={{ height: "100%", display: "flex", flexDirection: "column" }}
      >
        <CustomUpload
          setFilePaths={setFilePaths} 
          filePaths={filePaths} 
          setBtnDisabled={setBtnDisabled}
          btnDisabled={btnDisabled}
          isEdit={true}
          vendorPaymentId={detailRecord?.id || undefined}
          foreignId={detailRecord?.id || undefined}
          preCalFile={detailRecord?.preCalFile || undefined}
          type={detailRecord?.type || undefined}
          customConfig={{
            pdfHeight: '62vh',
            noShowUpload: true,
            noSubmitBtn: true,
            pageName: 'CheckApproval'
          }}
        />
        <div style={{textAlign: 'center', marginTop: 20}}>
          <Button onClick={() => setFiledModalFlag(false)}>
            cancel
          </Button>
        </div>
      </div>
      </Modal>

      <AplianceModal
        ref={AplianceRef}
        submitInitFn={submitInitFn}
      />

      <CustomModal
        ref={customModalRef}
        customConfig={{
          width: 500,
          deleteContent: currentRecord?.modalName,
          onOkFn: deleteFn,
        }} 
      />
    </div>
  );
});
export default MainTable;
